define(
    'viewmodels/site/error',[
        'lodash','knockout', 'atn/atn', 'checkPreInit/index',
         'checkPreInit/errorActions','dataSource/oemMessages'
    ],
    function(_,ko, atn, checkPreInit, errorActions,oemMessages) {
        'use strict';

        var isProper = ko.observable(true);
        
        return {
            recheck: recheck,
            isProper: isProper,
            activate: activate,
            messages: atn.config.messages.errorPage,
            oemMessages:oemMessages.oemMessages,
            capsProductName: atn.config.messages.general.capsProductName
        };

        function activate() {
            isProper(true);
            return true;
        }

        function recheck() {
            var data = {};
            checkPreInit.retestAPI(
                data,
                function(error) {
                    isProper(!error);
                    if (!error) {
                        errorActions.actuators.reloadWithNewBuild();
                    }
                }
            );
        }
    });
